export default __webpack_public_path__ + "static/media/docx_document.7a34dc67.svg";